import { Box, Card, Typography, useTheme } from '@mui/material';

/**
 * Properties for the contact card
 */
interface ContactCardProps {
  /** The type of contact card. Used in sentences throughout, so keep lower-case. */
  contactType: string;
}

/**
 * A contact card component to show on the legal view
 */
const ContactCard = (props: ContactCardProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        boxShadow: 0,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box padding="1em">
        <Typography
          sx={{
            fontWeight: '700',
          }}
          gutterBottom
        >
          How can you contact us about this {props.contactType}?
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{
            marginBottom: 2,
          }}
        >
          If you have any questions or concerns about the {props.contactType}{' '}
          please contact us.
        </Typography>
        <Typography variant="subtitle1">support@s3gsecurity.com</Typography>
      </Box>
    </Card>
  );
};

export default ContactCard;
